import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { OrderListSerialNumber } from 'features/OrdersList/ordersListForm';

const SerialTable: FC<{ serialNumbers: OrderListSerialNumber[] }> = ({ serialNumbers }) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper} elevation={3} style={{ marginTop: '20px' }}>
      <Table stickyHeader aria-label="serial numbers">
        <TableBody>
          {serialNumbers.map((sn: OrderListSerialNumber, idx: number) => (
            <TableRow>
              {idx === 0 && (
                <TableCell align="right">
                  <span> {t('products.serial numbers')}:</span>
                </TableCell>
              )}
              <TableCell align="right" colSpan={idx > 0 ? 2 : 1}>
                <span>{sn.value}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export { SerialTable };
